import { Outlet } from 'react-router';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const PublicRoute = ({ element }) => {
    const appData = useSelector((state) => state.appData)
    return appData.user ? <Navigate to="/" replace /> : element || <Outlet />;
};